"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeAddressModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var ChangeAddressModal = /** @class */ (function (_super) {
    __extends(ChangeAddressModal, _super);
    function ChangeAddressModal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeAddressRedirect = function () {
            var interactionProcess = _this.props.interaction.process;
            if (interactionProcess === services_1.INTERACTION_PROCESS_RENEWAL) {
                _this.executeEvent("change");
            }
            window.location.assign(_this.changeAddressJourneyLink(interactionProcess));
        };
        return _this;
    }
    ChangeAddressModal.prototype.render = function () {
        var _this = this;
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.props.toggle });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.props.isOpen, toggle: this.props.toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.props.toggle, close: closeBtn, children: "Change address" }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { className: "fs-28 font-weight-bold", children: "You\u2019ll need to make those changes again" }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Unless you\u2019ve clicked Save and confirm, any changes you\u2019ve made will be lost when you start a change of address. You\u2019ll need to reapply them here." })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex modal-footer", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: function (e) {
                            e.preventDefault();
                            _this.handleChangeAddressRedirect();
                        }, children: "Ok, I understand" }) })] }));
    };
    ChangeAddressModal.prototype.changeAddressJourneyLink = function (interactionProcess) {
        switch (interactionProcess) {
            case services_1.INTERACTION_PROCESS_MTA:
                return "/journey/init/product/AnnualHomeInsurance/process/mtaChangeAddress/preset/".concat(this.props.interaction.uistate.relativeInteractionId);
            case services_1.INTERACTION_PROCESS_RENEWAL:
                return "/journey/show/product/AnnualHomeInsurance/process/renewal/changeAddressPropertyDetails/".concat(this.props.interaction.uistate.relativeInteractionId);
            default:
                return "/journey/show/product/AnnualHomeInsurance/process/mtaSupportPortalAnnualHomeChangeAddress/presetPage/".concat(this.props.interaction.uistate.relativeInteractionId);
        }
    };
    return ChangeAddressModal;
}(plugin_journey_1.WidgetBase));
exports.ChangeAddressModal = ChangeAddressModal;
//# sourceMappingURL=ChangeAddressModal.js.map